var map = {
	"./fruity-bag.vue": 4893,
	"./fruity-basket.vue": 4409,
	"./fruity-error-page.vue": 6330,
	"./fruity-home-page.vue": 1343,
	"./fruity-input-weight.vue": 3986,
	"./fruity-page.vue": 6569,
	"./fruity-privacy-policy.vue": 7780,
	"./fruity-product-card.vue": 1104,
	"./fruity-product-quantity-input.vue": 7469,
	"./fruity-product.vue": 8440,
	"./fruity-products.vue": 9735,
	"./fruity-shop.vue": 5474,
	"./fruity-thank-you.vue": 8726,
	"./place-order.vue": 9995
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3295;